//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cmBlank from '@/components/cmBlank.vue'
import cmLoadmore from '@/components/cmLoadmore.vue'

export default {
  name: 'order',
  components: {
      cmBlank,cmLoadmore
  },
  data () {
    return {
      isActive:0,
      blankShow:false,
      loadStatus:false,
      loadmoreText:'正在加载。。。',
      busy:false,
      name:'',
      pageFlag:2,
      hasNext:0,
      lastId:0,
      list:[],
        statusArr:[
            {
              key:0,
              text:'全部'
          },
          {
              key:2,
              text:'待接单'
          },
          {
              key:6,
              text:'服务中'
          },
          {
              key:9,
              text:'已完成'
          },
        ]
    }
  },
  created(){
    if(!this.$func.getLocal('token')){
        window.location.href = "/";
        return false;
    }
    // this.isActive = Number(this.$route.params.i);
    // this.getCommunity();
  },
  methods:{
    copy(val){
        this.$func.copy(val,event);
    },
    search(){
        this.list = [];
        this.lastId = 0;
        this.hasNext = 0;
        this.isActive = 0;
        this.loadmore();
    },
    selectStatus(key){
        this.isActive = key;
        this.lastId = 0;
        this.list = [];
        this.loadmore();
    },
    getList(){
        this.$api.getOrderLists({last_id:this.lastId,page_flag:this.pageFlag,status:this.isActive,community_name:this.name,type:2}).then((res)=>{
          if(res){
            if(!this.lastId){
                this.blankShow = res.data.length > 0 ? false : true;
            }
            this.hasNext = res.hasNext;
            this.lastId = res.lastId;
            res.data.forEach((item)=>{
                this.list.push(item);
            });
          }
        })  
    },
    getCommunity(){
        this.$api.getCommunity({}).then((res)=>{
          if(res){
           
          }
        })  
    },
    loadmore(){
         if(this.lastId > 0 && !this.hasNext){
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '没有更多了。。。'
            return ;
        }
        this.loadStatus = true;
        this.loadmoreText = '正在加载。。。';
        this.getList();
        setTimeout(()=>{
            if(this.blankShow){
                this.busy = true;
                this.loadStatus = false;
                this.loadmoreText = '没有更多了。。。'
            }else{
                if(this.hasNext > 0){
                    this.loadStatus = false;
                    this.busy = false;
                }else{
                    this.busy = true;
                    this.loadStatus = true;
                    this.loadmoreText = '没有更多了。。。'
                }
            }
        },3000)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/groupOrder.vue